var Anhui = "Аньхой";
var Beijing = "Пекин";
var Chongqing = "Чунцин";
var Fujian = "Фуцзянь";
var Gansu = "Ганьсу";
var Guangdong = "Гуандун";
var Guangxi = "Гуанси-Чжуанский автономный район";
var Guizhou = "Гуйчжоу";
var Hainan = "Хайнань";
var Hebei = "Хэбэй";
var Heilongjiang = "Хэйлунцзян";
var Henan = "Хэнань";
var Hubei = "Хубэй";
var Hunan = "Хунань";
var Jiangsu = "Цзянсу";
var Jiangxi = "Цзянси";
var Jilin = "Цзилинь";
var Liaoning = "Ляонин";
var Ningxia = "Нинся-Хуэйский автономный район";
var Qinghai = "Цинхай";
var Shaanxi = "Шэньси";
var Shandong = "Шаньдун";
var Shanghai = "Шанхай";
var Shanxi = "Шаньси";
var Sichuan = "Сычуань";
var Tianjin = "Тяньцзинь";
var Tibet = "Тибетский автономный район";
var Xinjiang = "Синьцзян-Уйгурский автономный район";
var Yunnan = "Юньнань";
var Zhejiang = "Чжэцзян";
var CNStates = {
	Anhui: Anhui,
	Beijing: Beijing,
	Chongqing: Chongqing,
	Fujian: Fujian,
	Gansu: Gansu,
	Guangdong: Guangdong,
	Guangxi: Guangxi,
	Guizhou: Guizhou,
	Hainan: Hainan,
	Hebei: Hebei,
	Heilongjiang: Heilongjiang,
	Henan: Henan,
	Hubei: Hubei,
	Hunan: Hunan,
	"Inner Mongolia": "Внутренняя Монголия",
	Jiangsu: Jiangsu,
	Jiangxi: Jiangxi,
	Jilin: Jilin,
	Liaoning: Liaoning,
	Ningxia: Ningxia,
	Qinghai: Qinghai,
	Shaanxi: Shaanxi,
	Shandong: Shandong,
	Shanghai: Shanghai,
	Shanxi: Shanxi,
	Sichuan: Sichuan,
	Tianjin: Tianjin,
	Tibet: Tibet,
	Xinjiang: Xinjiang,
	Yunnan: Yunnan,
	Zhejiang: Zhejiang
};

export { Anhui, Beijing, Chongqing, Fujian, Gansu, Guangdong, Guangxi, Guizhou, Hainan, Hebei, Heilongjiang, Henan, Hubei, Hunan, Jiangsu, Jiangxi, Jilin, Liaoning, Ningxia, Qinghai, Shaanxi, Shandong, Shanghai, Shanxi, Sichuan, Tianjin, Tibet, Xinjiang, Yunnan, Zhejiang, CNStates as default };
